import React, { useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import AdminFeatureRow from './adminFeatureRow';
import Helmet from 'react-helmet';
import { useFeatures } from './apiHooks';

const AdminFeatures = () => {
  const [sortBy, setSortBy] = useState('idDesc');

  const {
    isLoading: loading,
    features,
    isError,
    error,
    refetch,
  } = useFeatures({
    sortBy,
  });

  useEffect(() => {
    refetch();
  }, [sortBy]);

  function setSortMethod(newSortBy) {
    let sortParam;

    switch (newSortBy) {
      case 'id':
      default:
        sortParam = sortBy === 'idAsc' ? 'idDesc' : 'idAsc';
    }

    setSortBy(sortParam);
  }

  const { formatMessage } = useIntl();

  return (
    <div>
      <Helmet>
        <title>{formatMessage({ id: 'admin.features.title' })}</title>
      </Helmet>
      <h3>
        <FormattedMessage id={'admin.features.title'} />
      </h3>

      <div className="m-b-3">
        <Link className="btn btn-default" to="/admin/features/create">
          <FormattedMessage id={'admin.button.create'} />
        </Link>
      </div>

      <table className="table table-striped admin__table admin__table m-bottom-margin">
        <thead>
          <tr>
            <th onClick={() => setSortMethod('id')} className="sortable" scope="col">
              Id
            </th>
            <th scope="col">Name</th>
            <th scope="col">Enabled</th>
            <th scope="col">Actions</th>
          </tr>
        </thead>
        <tbody>
          {features?.map((feature, index) => (
            <AdminFeatureRow feature={feature} key={index} />
          ))}
        </tbody>
      </table>
    </div>
  );
};

AdminFeatures.propTypes = {
  setLoading: PropTypes.func.isRequired,
  setError: PropTypes.func.isRequired,
};

AdminFeatures.defaultProps = {};

export default AdminFeatures;
